import Hero from './Hero/Hero';
import Register from '../HomePage/Forms/Register/Register';
import Signin from '../HomePage/Forms/Signin/Signin';
import styles from './Homepage.module.scss';

function HomePage() {
  return (
    <>
      <Hero />
      <div className={styles.Forms}>
        <Signin />
        Sample 1
        Sample 8
        Sample 3
        Sample 19


        GBuiabhgquj
        ia

        No I don't want import PropTypes from 'prop-types'

        Wooo

        What review??
        
        <Register />
      </div>
    </>
  );
}

export default HomePage;
